import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { AccordionCard } from 'src/components/AccordionCard';
import { DoubleColumnContainer } from 'src/components/DoubleColumnContainer';
import { UppercaseCaptionTypography } from 'src/features/visits/shared/components/UppercaseCaptionTypography';

type MedicalHistoryDoubleCardProps = {
  collapsed?: boolean;
  onSwitch?: () => void;
  label?: string;
  patientSide: ReactNode;
  providerSide: ReactNode;
  patientSideLabel?: ReactNode;
  providerSideLabel?: ReactNode;
};

export const MedicalHistoryDoubleCard: FC<MedicalHistoryDoubleCardProps> = (props) => {
  const { t } = useTranslation();
  const { collapsed, onSwitch, label, patientSide, providerSide, patientSideLabel, providerSideLabel } = props;

  return (
    <AccordionCard label={label} collapsed={collapsed} onSwitch={onSwitch}>
      <DoubleColumnContainer
        divider
        padding
        leftColumn={
          <>
            <UppercaseCaptionTypography sx={{ pb: 2 }}>
              {patientSideLabel || t('telemed.chart.patient')}
            </UppercaseCaptionTypography>
            {patientSide}
          </>
        }
        rightColumn={
          <>
            <UppercaseCaptionTypography sx={{ color: 'orange', pb: 2 }}>
              {providerSideLabel || t('telemed.chart.staffInput')}
            </UppercaseCaptionTypography>
            {providerSide}
          </>
        }
      />
    </AccordionCard>
  );
};
